<template>
  <nav>
    <v-toolbar flat>
      <v-toolbar-title>
        <span>Admin Page</span>
      </v-toolbar-title>
      <v-spacer />
      <router-link :to="{ name: 'Admin-Dashboard' }">
        <v-btn>Dashboard</v-btn>
      </router-link>
    </v-toolbar>
  </nav>
</template>

<script>
export default {
  name: "AdminNav"
};
</script>
